import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneComunali2026B extends Component {
  render() {
    let { regione} = this.props.params;
    let repoDettaglio = "/elezioni/withub/comunali-2026/comunali-ballottaggio/" + regione + "/" + regione + ".html";
    let repoFascione = "/elezioni/withub/comunali-2026/comunali-ballottaggio/fascione-composto.html";
    return (
    <div className="App">
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
        <EWH id="ewh-fascione" repo={repoFascione} />
    </div>
    )
  }
}

export default withParams(RegioneComunali2026B)
